import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import api from '../../utils/api';
import CIUDADES from '../../data/ciudadesColombia';
import toast from 'react-hot-toast';
import Breadcrumb from '../../components/Breadcrumb';
import '../../styles/checkout.css';
import { track } from '../../utils/analytics';
import ReactPixel from 'react-facebook-pixel';
import { useWompiCheckout } from '../../utils/useWompiCheckout';

const fmtCOP = v => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(v||0);

export default function Checkout() {
  const { items, total, vaciar, cambiarCantidad, quitar } = useCart();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    nombre_cliente:'', email_cliente:'', telefono_cliente:'',
    documento_cliente:'', direccion_entrega:'', ciudad_entrega:'',
    departamento_entrega:'', notas:'', metodo_pago:'wompi'
  });
  const [costoEnvio, setCostoEnvio]     = useState(null);
  const [infoEnvio, setInfoEnvio]       = useState(null);
  const [codigoCupon, setCodigoCupon]   = useState('');
  const [cuponAplicado, setCuponAplicado] = useState(null);
  const [wompiConfig, setWompiConfig]   = useState(null);
  const [pedidoCreado, setPedidoCreado] = useState(null);
  const [pagoWidget, setPagoWidget]     = useState(false);
  const [cuponLoading, setCuponLoading] = useState(false);
  const { pagar, loading } = useWompiCheckout();

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const [ciudadQuery, setCiudadQuery] = React.useState('');
  const [ciudadOpen, setCiudadOpen] = React.useState(false);
  const ciudadesFiltradas = ciudadQuery.length >= 2
    ? CIUDADES.filter(c => c.ciudad.toLowerCase().includes(ciudadQuery.toLowerCase())).slice(0, 8)
    : [];

  useEffect(() => {
    api.get('/wompi/config').then(r => setWompiConfig(r.data)).catch(() => {});
    ReactPixel.track('InitiateCheckout', {
      value: total,
      currency: 'COP',
      num_items: items.reduce((s, i) => s + i.cantidad, 0),
    });
    track('init_checkout', { valor: total, meta: { num_items: items.reduce((s, i) => s + i.cantidad, 0) } });
  }, []);

  // Recalcula envío cada vez que cambia la ciudad
  useEffect(() => {
    const ciudad = form.ciudad_entrega.trim();
    if (!ciudad) { setCostoEnvio(null); setInfoEnvio(null); return; }
    const t = setTimeout(async () => {
      try {
        const r = await api.post('/envios/calcular', { ciudad, valor_pedido: total });
        const op = r.data.opciones[0];
        setCostoEnvio(op.precio);
        setInfoEnvio(op);
      } catch { setCostoEnvio(null); setInfoEnvio(null); }
    }, 600);
    return () => clearTimeout(t);
  }, [form.ciudad_entrega, total]);

  const aplicarCupon = async () => {
    if (!codigoCupon.trim()) return toast.error('Ingresa un código');
    setCuponLoading(true);
    try {
      const r = await api.post('/cupones/validar', { codigo: codigoCupon.trim(), subtotal: total, email_cliente: form.email_cliente });
      setCuponAplicado(r.data);
      toast.success(r.data.mensaje);
    } catch(err) { toast.error(err.response?.data?.error || 'Cupón no válido'); setCuponAplicado(null); }
    finally { setCuponLoading(false); }
  };

  const descuentoCupon = cuponAplicado?.descuento || 0;
  const envio          = costoEnvio ?? 0;
  const totalFinal     = total + envio - descuentoCupon;

  const confirmar = async () => {
    if (!form.nombre_cliente || !form.email_cliente || !form.direccion_entrega || !form.ciudad_entrega)
      return toast.error('Completa todos los campos requeridos');
    if (costoEnvio === null) return toast.error('Ingresa una ciudad valida');
    if (!items.length) return toast.error('El carrito esta vacio');
    try {
      const resultado = await pagar({
        ...form,
        items: items.map(i => ({ producto_id: i.id, cantidad: i.cantidad, variaciones: i.variaciones || [] })),
        costo_envio: envio,
        descuento: descuentoCupon,
        cupon_codigo: cuponAplicado?.codigo || null,
        metodo_pago: 'wompi',
      });
      vaciar();
      navigate('/pedido-ok', { state: { numero: resultado.numero, total: resultado.total, metodo_pago: 'wompi', transaccion_id: resultado.transaccion_id } });
    } catch(err) {
      toast.error(err.message);
    }
  };


  if (!items.length) return (
    <div style={{ minHeight:'60vh', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:16, padding:40 }}>
      <div style={{ fontSize:64 }}>🛒</div>
      <h2 style={{ fontFamily:'var(--font-display)', fontSize:24, color:'var(--forest)' }}>Tu carrito está vacío</h2>
      <Link to="/" className="btn btn-primary">Ver productos</Link>
    </div>
  );

  return (
    <div>
      <Breadcrumb items={[{ label:'Wawita', href:'/' }, { label:'Finalizar compra' }]} />
      <div className="checkout-layout">

        {/* FORMULARIO */}
        <div className="checkout-form-col">
          <h2 style={{ fontFamily:'var(--font-display)', fontSize:28, color:'var(--forest)', marginBottom:24 }}>Datos de entrega</h2>

          <div className="card" style={{ marginBottom:20 }}>
            <div className="card-body">
              <div className="form-grid-2">
                {[
                  { k:'nombre_cliente',      l:'Nombre completo *',    ph:'María García',           full:true },
                  { k:'email_cliente',       l:'Correo electrónico *', ph:'tu@email.com',            type:'email' },
                  { k:'telefono_cliente',    l:'Teléfono / WhatsApp',  ph:'+57 300...' },
                  { k:'documento_cliente',   l:'CC / NIT',             ph:'123456789' },
                  { k:'direccion_entrega',   l:'Dirección completa *', ph:'Calle 10 # 25-30, Barrio...', full:true },

                  { k:'notas',               l:'Notas del pedido',     ph:'Instrucciones especiales...', full:true },
                ].map(f => (
                  <div key={f.k} className="form-group" style={f.full ? { gridColumn:'1/-1' } : {}}>
                    <label className="form-label">{f.l}</label>
                    <input className="form-input" type={f.type||'text'} placeholder={f.ph}
                      value={form[f.k]} onChange={e => set(f.k, e.target.value)} />
                  </div>
                ))}
                {/* Ciudad autocomplete */}
                <div className="form-group" style={{ position:'relative' }}>
                  <label className="form-label">Ciudad *</label>
                  <input className="form-input" placeholder="Escribe tu ciudad..."
                    value={ciudadQuery || form.ciudad_entrega}
                    onChange={e => {
                      setCiudadQuery(e.target.value);
                      setCiudadOpen(true);
                      if (!e.target.value) { set('ciudad_entrega',''); set('departamento_entrega',''); }
                    }}
                    onFocus={() => setCiudadOpen(true)}
                    onBlur={() => setTimeout(() => setCiudadOpen(false), 200)}
                    autoComplete="off"
                  />
                  {ciudadOpen && ciudadesFiltradas.length > 0 && (
                    <div style={{ position:'absolute', top:'100%', left:0, right:0, background:'#fff', border:'1.5px solid rgba(28,58,30,0.15)', borderRadius:'var(--r-md)', zIndex:100, boxShadow:'0 8px 24px rgba(0,0,0,0.1)', maxHeight:240, overflowY:'auto' }}>
                      {ciudadesFiltradas.map(c => (
                        <div key={c.ciudad + c.departamento}
                          onMouseDown={() => {
                            set('ciudad_entrega', c.ciudad);
                            set('departamento_entrega', c.departamento);
                            setCiudadQuery('');
                            setCiudadOpen(false);
                          }}
                          style={{ padding:'10px 16px', cursor:'pointer', fontSize:14, borderBottom:'1px solid rgba(28,58,30,0.06)' }}
                          onMouseEnter={e => e.target.style.background='rgba(159,190,106,0.1)'}
                          onMouseLeave={e => e.target.style.background='transparent'}
                        >
                          <span style={{ fontWeight:600, color:'var(--forest)' }}>{c.ciudad}</span>
                          <span style={{ color:'var(--ink-faint)', fontSize:12, marginLeft:8 }}>{c.departamento}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {/* Departamento auto */}
                <div className="form-group">
                  <label className="form-label">Departamento</label>
                  <input className="form-input" value={form.departamento_entrega} readOnly
                    style={{ background:'var(--cream-dark)', color:'var(--ink-faint)' }}
                    placeholder="Se completa automáticamente" />
                </div>
              </div>
            </div>
          </div>

          {/* Info de envío automática */}
          {infoEnvio && (
            <div className="card">
              <div className="card-header"><span className="card-title">Envío</span></div>
              <div className="card-body">
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 0', border:'2px solid #9FBE6A', borderRadius:'var(--r-md)', padding:'14px 18px', background:'rgba(159,190,106,0.08)' }}>
                  <div>
                    <div style={{ fontWeight:700, fontSize:14, color:'var(--forest)' }}>{infoEnvio.nombre}</div>
                    <div style={{ fontSize:12, color:'var(--ink-light)', marginTop:3 }}>{infoEnvio.tiempo}</div>
                  </div>
                  <div style={{ fontWeight:900, fontSize:18, color: infoEnvio.gratis ? 'var(--sage)' : 'var(--forest)', flexShrink:0 }}>
                    {infoEnvio.gratis ? 'GRATIS' : fmtCOP(infoEnvio.precio)}
                  </div>
                </div>
                {infoEnvio.gratis && (
                  <div style={{ fontSize:12, color:'var(--sage)', fontWeight:700, textAlign:'center', marginTop:8 }}>
                    🎉 Tu pedido califica para envío gratis
                  </div>
                )}
              </div>
            </div>
          )}

          {!infoEnvio && form.ciudad_entrega && (
            <div style={{ fontSize:13, color:'var(--ink-faint)', textAlign:'center', padding:'12px 0' }}>Calculando envío...</div>
          )}
          {!form.ciudad_entrega && (
            <div style={{ fontSize:13, color:'var(--ink-faint)', textAlign:'center', padding:'12px 0' }}>Ingresa tu ciudad para ver el costo de envío</div>
          )}
        </div>

        {/* RESUMEN */}
        <div className="checkout-summary-col">
          <div className="card">
            <div className="card-header"><span className="card-title">Resumen del pedido</span></div>
            <div className="card-body">

              <div style={{ display:'flex', flexDirection:'column', gap:12, marginBottom:16 }}>
                {items.map(item => (
                  <div key={item._key || item.id} style={{ display:'flex', gap:12, alignItems:'center', padding:'10px 0', borderBottom:'1px solid rgba(28,58,30,0.07)' }}>
                    {/* Imagen */}
                    <div style={{ width:56, height:56, borderRadius:10, overflow:'hidden', background:'var(--cream-dark)', flexShrink:0, position:'relative' }}>
                      {item.imagen_principal
                        ? <img src={item.imagen_principal} alt={item.nombre} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                        : <div style={{ width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:24 }}>🌿</div>}
                      <span style={{ position:'absolute', top:-4, right:-4, background:'var(--forest)', color:'#fff', borderRadius:'50%', width:18, height:18, fontSize:10, fontWeight:900, display:'flex', alignItems:'center', justifyContent:'center' }}>{item.cantidad}</span>
                    </div>
                    {/* Info */}
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontWeight:700, fontSize:13, color:'var(--forest)', marginBottom:2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{item.nombre}</div>
                      {item.variaciones && item.variaciones.length > 0 && (
                        <div style={{ fontSize:11, color:'var(--ink-faint)', marginBottom:4 }}>{item.variaciones.map(v => v.valor).join(' · ')}</div>
                      )}
                      <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                        <button onClick={() => cambiarCantidad(item._key||item.id, item.cantidad-1)} style={{ width:22, height:22, border:'1px solid rgba(28,58,30,0.2)', borderRadius:6, background:'#fff', cursor:'pointer', fontSize:14, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700 }}>-</button>
                        <span style={{ fontSize:13, fontWeight:700, minWidth:16, textAlign:'center' }}>{item.cantidad}</span>
                        <button onClick={() => cambiarCantidad(item._key||item.id, item.cantidad+1)} style={{ width:22, height:22, border:'1px solid rgba(28,58,30,0.2)', borderRadius:6, background:'#fff', cursor:'pointer', fontSize:14, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700 }}>+</button>
                        <button onClick={() => quitar(item._key||item.id)} style={{ background:'none', border:'none', color:'var(--terra)', cursor:'pointer', fontSize:11, fontWeight:700, marginLeft:4 }}>Eliminar</button>
                      </div>
                    </div>
                    {/* Precio */}
                    <div style={{ fontWeight:900, fontSize:14, color:'var(--forest)', flexShrink:0 }}>{fmtCOP(item.precio * item.cantidad)}</div>
                  </div>
                ))}
              </div>

              {/* Cupón */}
              <div style={{ padding:'14px 0', borderBottom:'1px solid rgba(28,58,30,0.1)' }}>
                <div style={{ fontWeight:700, fontSize:13, color:'var(--forest)', marginBottom:8 }}>Código de cupón</div>
                {!cuponAplicado ? (
                  <div style={{ display:'flex', gap:8 }}>
                    <input className="form-input" style={{ flex:1, fontSize:13, padding:'8px 12px', fontFamily:'monospace', letterSpacing:1 }}
                      placeholder="Ej: WAWITA20" value={codigoCupon}
                      onChange={e => setCodigoCupon(e.target.value.toUpperCase())}
                      onKeyDown={e => e.key==='Enter' && aplicarCupon()} />
                    <button className="btn btn-outline btn-sm" onClick={aplicarCupon} disabled={cuponLoading}>
                      {cuponLoading ? '...' : 'Aplicar'}
                    </button>
                  </div>
                ) : (
                  <div style={{ background:'rgba(159,190,106,0.15)', borderRadius:10, padding:'10px 14px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <div>
                      <div style={{ fontFamily:'monospace', fontWeight:900, fontSize:14, color:'var(--forest)' }}>{cuponAplicado.codigo}</div>
                      <div style={{ fontSize:12, color:'var(--sage)', marginTop:2 }}>{cuponAplicado.descripcion}</div>
                    </div>
                    <button onClick={() => { setCuponAplicado(null); setCodigoCupon(''); }} style={{ background:'none', border:'none', color:'var(--terra)', cursor:'pointer', fontWeight:700, fontSize:13 }}>Quitar</button>
                  </div>
                )}
              </div>

              {/* Totales */}
              <div style={{ padding:'12px 0' }}>
                <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:6 }}>
                  <span style={{ color:'var(--ink-light)' }}>Subtotal</span>
                  <span style={{ fontWeight:700 }}>{fmtCOP(total)}</span>
                </div>
                {descuentoCupon > 0 && (
                  <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:6 }}>
                    <span style={{ color:'var(--sage)', fontWeight:700 }}>Cupón {cuponAplicado.codigo}</span>
                    <span style={{ fontWeight:700, color:'var(--sage)' }}>- {fmtCOP(descuentoCupon)}</span>
                  </div>
                )}
                <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:6 }}>
                  <span style={{ color:'var(--ink-light)' }}>Envío</span>
                  <span style={{ fontWeight:700, color: envio===0&&costoEnvio!==null ? 'var(--sage)' : 'var(--forest)' }}>
                    {costoEnvio === null ? 'Ingresa tu ciudad' : envio === 0 ? 'Gratis' : fmtCOP(envio)}
                  </span>
                </div>
                <div style={{ display:'flex', justifyContent:'space-between', padding:'12px 0', fontWeight:900, fontSize:20, borderTop:'1px solid rgba(28,58,30,0.1)', marginTop:6 }}>
                  <span>Total</span>
                  <span style={{ color:'var(--forest)' }}>{fmtCOP(totalFinal)}</span>
                </div>
              </div>



              <button onClick={confirmar} disabled={loading} style={{ width:'100%', padding:'16px', fontSize:16, fontWeight:800, background: loading ? '#ccc' : '#1C3A1E', color:'#9FBE6A', border:'none', borderRadius:'var(--r-lg)', cursor: loading ? 'not-allowed' : 'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:10, fontFamily:'var(--font-body)', transition:'all 0.2s' }}>
                {loading ? (
                  <><span className="spinner" style={{width:18,height:18,borderColor:'#9FBE6A',borderTopColor:'transparent'}} /> Procesando...</>
                ) : (
                  <>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="2" y="5" width="20" height="14" rx="2" stroke="#9FBE6A" strokeWidth="2"/><path d="M2 10h20" stroke="#9FBE6A" strokeWidth="2"/></svg>
                    Pagar de forma segura
                  </>
                )}
              </button>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:6, marginTop:10 }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M12 2L8 6H4v4L2 12l2 2v4h4l4 4 4-4h4v-4l2-2-2-2V6h-4L12 2z" stroke="var(--ink-faint)" strokeWidth="1.5"/></svg>
                <span style={{ fontSize:11, color:'var(--ink-faint)' }}>Pago 100% seguro con Wompi · Tarjeta, PSE, Nequi, Bancolombia</span>
              </div>
              <Link to="/" style={{ display:'block', textAlign:'center', marginTop:12, fontSize:13, color:'var(--ink-faint)' }}>Seguir comprando</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
